import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { AccionService } from './services/accion.service';
import { IAccion, IAccionResponse } from './interfaces/accion.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-abc-acciones',
  templateUrl: './abc-acciones.component.html',
  providers: [MessageService]
})
export class AbcAccionesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedAccion: IAccion | null = null;
  dataSource: IAccion[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  resultadosCount: { [key: string]: number } = {}; // Conteo de resultados por acción

  displayedColumns = [
    { field: 'saccion', header: 'Clave', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'tipo', header: 'Tipo', sortable: true },
    { field: 'costo', header: 'Costo', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private accionService: AccionService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    
    this.accionService.getAccionesDefault().subscribe({
      next: (response: IAccionResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
          // Cargar el conteo de resultados para cada acción
          this.cargarConteoResultados();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las acciones'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las acciones'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  cargarConteoResultados(): void {
    this.dataSource.forEach(accion => {
      this.accionService.getResultadosAccionCount(accion.saccion).subscribe({
        next: (response) => {
          if (response.success && response.data && response.data.length > 0) {
            this.resultadosCount[accion.saccion] = response.data[0].cantidad;
          } else {
            this.resultadosCount[accion.saccion] = 0;
          }
        },
        error: (error) => {
          console.error('Error cargando conteo de resultados para:', accion.saccion, error);
          this.resultadosCount[accion.saccion] = 0;
        }
      });
    });
  }

  openCreate(): void {
    this.selectedAccion = null;
    this.displayDialog = true;
  }

  openUpdate(row: IAccion): void {
    this.selectedAccion = { ...row };
    this.displayDialog = true;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  onFormClosed(): void {
    this.displayDialog = false;
    this.loadData();
  }

  onCancelled(): void {
    this.displayDialog = false;
  }

  openDelete(row: IAccion): void {
    // Verificar si tiene resultados asociados
    if (this.resultadosCount[row.saccion] > 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Advertencia',
        detail: 'No se puede eliminar la acción: tiene resultados asociados'
      });
      return;
    }

    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Desea eliminar la acción ${row.saccion}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        this.accionService.deleteAccion(row.saccion).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Acción eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar la acción'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar la acción'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedAccion = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }
} 